<template>
  <div :class="['product-code', { 'product-code--collapsed': !isSidebarOpen }]">
   <div v-if="!isSidebarOpen" class="collapsed-sidebar">
      <img v-tooltip="'Expand Products'" @click="handleSidebarToggle" src="~@/assets/images/icons/expand-sidebar.svg"
        width="13px" alt="" />
      <div class="divider" />
      <div class="vertical-text">
        <span>PRODUCTS</span>
      </div>
      <div v-if="selectedProduct" class="divider-light" />
      <div v-if="selectedProduct" class="selectedProduct-viewer">
        <div v-tooltip="getStatusTooltip(selectedProductStatus)"
          :class="['material-status', getStatusClass(selectedProductStatus)]"></div>
        <div class="vertical-text-selected">{{ selectedProduct.product_code_name }}</div>
      </div>
    </div>
    <div v-else>
    <div  class="product-code__header s  ">
     <div class=" setting-header space-between p-2 v-center">
      <h4 class="setting-name">Product Code</h4>
        <div class="product-code-icons">
                    <img
                    v-tooltip="'Collapse Products'"
                    @click="handleSidebarToggle"
                    src="~@/assets/images/icons/collapse-sidebar.svg"
                    width="13px"
                    alt=""
                  />
                    <img
                    v-show="showAddProduct"
                    @click="openAddMaterialModal"
                    v-tooltip="'Add Product Code'"
                    src="~@/assets/images/icons/add-new-icon.svg"
                    width="20px"
                    alt=""
                  />
      </div>
     </div>
     <div class="m prod-code-search">
        <div class="prod-code-search-btnbox">
          <div ref="selectedBg" class="prod-code-search-selectedbg"></div>
          <div class="prod-code-search-prodbtn" @click="searchForProd" title="product code search">Prod</div>
          <div class="prod-code-search-bombtn" @click="searchForBoms" title="bom name search">Bom</div>
        </div>
        <input
            class="prod-code-search-input"
            type="text"
            @input="updateOnSearch"
            :placeholder="searchType === 'bomLevel' ? 'Search by BOM name' : 'Search by product code'"
            v-model="searchKeyWord"
          />
        </div>
    </div>

    <div class="product-code__list">
      <product-code-item
        v-for="productCode in productTreeFiltered"
        :key="productCode.cid"
        :productObject="productCode"
      />
    </div>
    <modal
      :open="addMaterialModal"
      @close="closeAddMaterialModal"
      title="Add Product"
    >
      <create-material-master v-if="(isTenantAdmin || isProjectAdmin || !collaborator) && addMaterialModal"
        @created="closeAddMaterialModal"
        @close="closeAddMaterialModal"
        :bomForm="true"
      />
    </modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Modal from '../../common/modal.vue'
import CreateMaterialMaster from '../../materialMaster/createMaterialMaster.vue'
import productCodeItem from './productCodeItem.vue'
import { alert } from '@/plugins/notification'
import { startGlobalCursorLoader, stopGlobalCursorLoader } from '@/utils/globalCursorLoader'
import { GetAllSequenceTemplates } from '@/api'
import config from '@/config'
export default {
  components: { productCodeItem, Modal, CreateMaterialMaster },
  name: 'ProductCodeList',
  data () {
    return {
      addMaterialModal: false,
      searchKeyWord: '',
      productTreeFiltered: null,
      searchType: null,
      isWideScreen: window.innerWidth > 1366,
      isSidebarOpen: true
    }
  },
  computed: {
    ...mapGetters('productBom', ['productCodeTree', 'bomProdSearchKeyword', 'selectedProductCode']),
    ...mapGetters(['user', 'isTenantAdmin', 'isProjectAdmin', 'collaborator']),
    showAddProduct () {
      if (this.collaborator) return false
      else { return (this.user.tenantLevelRole === 'ADMIN' || this.user.tenantLevelRole === 'COLLABORATOR' || this.user.tenantLevelRole === 'EDITOR') }
    },
    selectedProduct () {
      const items = this.productCodeTree.items || {}
      return Object.values(items).find(item => item.product_code === this.selectedProductCode) || null
    },
    selectedProductStatus () {
      return this.selectedProduct.status || (this.selectedProduct.active ? 1 : 2)
    }

  },
  methods: {
    handleResize () {
      this.isWideScreen = window.innerWidth > 1366
    },
    openAddMaterialModal () {
      startGlobalCursorLoader()
      Promise.all([GetAllSequenceTemplates(config.CORE_FEATURES.MATERIAL), GetAllSequenceTemplates(config.CORE_FEATURES.PRODUCT_CODE)])
        .then(([materialRes, productCodeRes]) => {
          if (materialRes.core_sequence_id_template?.length && productCodeRes.core_sequence_id_template?.length) {
            this.addMaterialModal = true
          } else {
            alert('No sequence Id is asscociated with your tenant')
          }
        }).catch(() => {
          alert('Failed to fetch, please try again later')
        }).finally(() => {
          stopGlobalCursorLoader()
        })
    },
    closeAddMaterialModal (prodCode) {
      // prodCode -- means material is created with product code
      this.addMaterialModal = false
      if (prodCode) { this.$store.dispatch('productBom/getAllProductCode') }
    },
    // this function will search the name of given  product code  list
    updateOnSearch () {
      this.searchKeyWord = (this.searchKeyWord).toLowerCase()
      if (this.searchType === 'bomLevel' && this.searchKeyWord) {
        this.$store.dispatch('productBom/getAllProductCode', { searchKeyword: this.searchKeyWord, searchType: 'bomLevel' })
        this.$store.dispatch('productBom/addProdBomSearchKeyword', this.searchKeyWord)
        return
      } else if (this.searchType === 'bomLevel') {
        this.$store.dispatch('productBom/getAllProductCode')
      }
      this.$store.dispatch('productBom/addProdBomSearchKeyword', '')
      this.productTreeFiltered = this.productCodeTree.tree?.filter((product) => {
        const item = this.productCodeTree.items[product.cid]
        return (
    item.product_code_name?.toLowerCase().includes(this.searchKeyWord) ||
    item.material_id?.toLowerCase().includes(this.searchKeyWord)
        )
      })
    },
    searchForBoms () {
      this.$refs.selectedBg.style.left = '50%'
      this.searchType = 'bomLevel'
      this.updateOnSearch()
    },
    searchForProd () {
      this.$refs.selectedBg.style.left = '2px'
      this.searchType = null
      this.$store.dispatch('productBom/getAllProductCode')
      this.updateOnSearch()
    },
    handleSidebarToggle () {
      this.isSidebarOpen = !this.isSidebarOpen
      this.$emit('handle-sidebar')
    },
    getStatusTooltip (status) {
      switch (status) {
      case config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE:
        return 'Active'
      case config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE:
        return 'Obsolete'
      case config.MATERIAL_STATUS_INVERTED_MAP.LOCKED:
        return 'Locked'
      case config.MATERIAL_STATUS_INVERTED_MAP.RELEASED:
        return 'Released'
      default:
        return 'Unknown status'
      }
    },
    getStatusClass (status) {
      switch (status) {
      case config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE:
        return 'status-active'
      case config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE:
        return 'status-obsolete'
      case config.MATERIAL_STATUS_INVERTED_MAP.LOCKED:
        return 'status-locked'
      case config.MATERIAL_STATUS_INVERTED_MAP.RELEASED:
        return 'status-released'
      default:
        return ''
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.updateOnSearch()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    productCodeTree () {
      if (this.searchKeyWord === '' || this.searchType === 'bomLevel') { this.productTreeFiltered = this.productCodeTree.tree } else {
        this.updateOnSearch()
      }
    }
  }

}
</script>

<style lang="scss" scoped >
$status-colors: (
  active: #16A34A,
  released: #2563EB,
  obsolete: #6B7280,
  locked: #DC2626
);
.product-code {
  width: 100%;
  height: 100%;
  overflow: auto;
  // background-color: var(--bg-color);
  border-right: 1px solid var(--gray-bgcolor);
  position: relative;

  &-icons {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__add-btn {
    transition: padding 0.2s ease, min-width 0.2s ease;

    &--compact {
      padding: 4px 7px;
      // min-width: 32px;
      line-height: 1;
    }
  }

  &__header {
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--gray-bgcolor);
    display: flex;
    flex-direction: column;
  }

  &--collapsed {
    width: max-content;
    max-width: 32px;
    overflow: hidden;
  }
}

.prod-code-search {
  position: relative;
  display: flex;
  align-items: center;
  width: calc(100% - 10px);
  margin: 0 5px 6px;
  min-height: 38px;
  background: #fff;
  border: 1px solid #d7dde5;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  overflow: hidden;

  &:focus-within {
    border-color: rgba(var(--brand-rgb), 0.55);
    box-shadow: 0 0 0 3px rgba(var(--brand-rgb), 0.12);
  }

  &-input {
    width: 100%;
    height: 100%;
    min-height: 38px;
    border: none;
    outline: none;
    background: transparent;
    font-size: var(--text-s);
    color: #1f2937;
    padding: 0 118px 0 10px;

    &::placeholder {
      color: #9ca3af;
    }
  }

  &-btnbox {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    width: 88px;
    height: 24px;
    background: #f3f4f6;
    border: 1px solid #d9dee7;
    border-radius: 9px;
    cursor: pointer;
    overflow: hidden;
  }

  &-prodbtn,
  &-bombtn {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 11px;
    font-weight: 600;
    color: #475467;
    user-select: none;
    transition: color 0.25s ease;
  }

  &-selectedbg {
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: 1;
    width: calc(50% - 2px);
    height: calc(100% - 4px);
    background: linear-gradient(180deg, var(--brand-color) 0%, #d99a17 100%);
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(217, 154, 23, 0.24);
    transition: left 0.3s ease;
  }
}

.collapsed-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px 0 0 0;

  .divider {
    height: 1px;
    width: 20px;
    background: #ebe6e7;
  }

  .divider-light {
    height: 1px;
    width: 20px;
    background: #ebe6e7;
  }

  .vertical-text {
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      transform-origin: center;
      transform: rotate(-90deg);
      font-size: var(--text-xs1);
      letter-spacing: 1px;
      color: #99a1af;
      font-weight: bold;
    }
  }

  .selectedProduct-viewer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    .vertical-text-selected {
      writing-mode: sideways-lr;
      font-size: var(--text-xs1);
      color: #a07030;
      font-weight: bold;
    }
  }

}

@media screen and (max-width: 1366px) {
  .prod-code-search {
    min-height: 28px;

    &-input {
      min-height: 28px;
      padding: 0 80px 0 8px;
      font-size: 12px;
    }

    &-btnbox {
      right: 4px;
      width: 72px;
      height: 20px;
      border-radius: 7px;
    }

    &-prodbtn,
    &-bombtn {
      font-size: 10px;
    }

    &-selectedbg {
      top: 1px;
      height: calc(100% - 2px);
      border-radius: 6px;
    }
  }
}
.material-status {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);

  @each $name, $color in $status-colors {
    &.status-#{$name} {
      background-color: $color;
    }
  }
}
</style>
